"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepareThumbnailResult = void 0;
var uuid_1 = require("uuid");
/**
 * A listener for a thumbnail request. We create one of these for each request in the queue.
 * @param {string} jobId The id of the job, oftentimes a field id.
 */
var PrepareThumbnailResult = /** @class */ (function () {
    function PrepareThumbnailResult(jobId) {
        var _this = this;
        /**
         * Custom on cancel handler.
         */
        this.onCancelRequest = null;
        this.cancelRequested = false;
        this.promiseResolve = null;
        this.promiseReject = null;
        this.id = (0, uuid_1.v4)();
        this.jobId = jobId;
        /**
         * Extremely simple handler that can be overriden
         */
        this.result = new Promise(function (resolve, reject) {
            _this.promiseResolve = resolve;
            _this.promiseReject = reject;
        });
    }
    /**
     * Calls promiseResolve if it's been set.
     * Prevents calls if we've cancelled this request.
     */
    PrepareThumbnailResult.prototype.resolve = function (result) {
        if (!this.cancelRequested && this.promiseResolve) {
            this.promiseResolve(result);
        }
    };
    /**
     * Calls promiseReject if it's been set.
     * Prevents calls if we've cancelled this request.
     */
    PrepareThumbnailResult.prototype.reject = function () {
        if (!this.cancelRequested && this.promiseReject) {
            this.promiseReject();
        }
    };
    /**
     * Kills this request.
     */
    PrepareThumbnailResult.prototype.cancel = function () {
        if (!this.cancelRequested) {
            this.cancelRequested = true;
            if (this.onCancelRequest) {
                this.onCancelRequest(this);
            }
        }
    };
    return PrepareThumbnailResult;
}());
exports.PrepareThumbnailResult = PrepareThumbnailResult;
exports.default = PrepareThumbnailResult;
